import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';

import './styles.css';

const isServer = typeof window === 'undefined';

type Props = {
  /** An estimate of the element's height */
  defaultHeight?: number;
  /** How far outside the viewport in pixels should elements be considered visible?  */
  visibleOffset?: number;
  // root?: HTMLElement | Document | null;
  root?: any;
  children: React.ReactNode;
  tag?: any;
};

const RenderIfVisible = ({
  defaultHeight = 300,
  visibleOffset = 200,
  root = null,
  tag: CustomTag = 'tr',
  children,
}: Props) => {
  const [isVisible, setIsVisible] = useState<boolean>(isServer);
  const placeholderHeight = useRef<number>(defaultHeight);
  const intersectionRef = useRef<HTMLElement>(null);

  // Set visibility with intersection observer

  useLayoutEffect(() => {
    // ref: https://stackoverflow.com/questions/67069827/cleanup-ref-issues-in-react
    let observerRefValue: HTMLElement | null = null;
    if (intersectionRef.current) {
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('fadeIn');
            } else {
              entry.target.classList.remove('fadeIn');
            }
          });
          if (typeof window !== 'undefined' && window.requestIdleCallback) {
            window.requestIdleCallback(
              () => {
                setIsVisible(entries[0].isIntersecting);
              },
              {
                timeout: 100,
              },
            );
          } else {
            setIsVisible(entries[0].isIntersecting);
          }
        },
        {
          root,
          rootMargin: `${visibleOffset}px 0px ${visibleOffset}px 0px`,
        },
      );
      observerRefValue = intersectionRef.current; // <-- save ref value
      observer.observe(intersectionRef.current);
      return () => {
        if (observerRefValue) {
          observer.unobserve(observerRefValue);
        }
      };
    }
    return () => {};
  }, [intersectionRef, root, visibleOffset]);

  // Set true height for placeholder element after render.
  useEffect(() => {
    if (intersectionRef.current && isVisible) {
      placeholderHeight.current = intersectionRef.current.offsetHeight;
    }
  }, [isVisible, intersectionRef]);

  return (
    <CustomTag className="custom-tag" ref={intersectionRef}>
      {/* <CustomTag> */}
      {isVisible ? (
        <>{children}</>
      ) : (
        <td>
          <section style={{ height: placeholderHeight.current }} />
        </td>
      )}
    </CustomTag>
  );
};

export default RenderIfVisible;
